import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const CommsLpStatusRuleModelSchema = z
  .object({
    id: z.string(),
    comms_lp_status_id: z.string(),
    source_type: z.string(),
    matched_status_id: z.number().nullish(),
    matched_decision_status_id: z.string().nullish(),
    is_default: z.boolean()
  })
  .strict()

const CommsLpStatusRuleModelFields = makeFieldKeys(CommsLpStatusRuleModelSchema)

export type CommsLpStatusRuleModel = z.infer<typeof CommsLpStatusRuleModelSchema>

function validateCommsLpStatusRuleModel(data: unknown): CommsLpStatusRuleModel {
  try {
    return validateWithZodSchema(CommsLpStatusRuleModelSchema, data, 'comms lp status rule model')
  } catch (error) {
    throw new Error(`Comms lp status rule model validation failed: ${error}`)
  }
}
